import { lazy, Route } from '@tanstack/router'

import { profileRoute } from '.'

const RedeemBonusDetails = lazy(
  () => import('../../pages/profile/redeem-bonus-details'),
)

export const redeemBonusDetailsRoute = new Route({
  getParentRoute: () => profileRoute,
  path: 'redeem-bonus-details',
  component: RedeemBonusDetails,
})
